<ng-template
  #template
  let-config="config"
  let-columnIds="columnIds"
  let-selectAllCheckbox="selectAllCheckbox"
  let-allRowsSelected$="allRowsSelected$"
  let-isIndeterminate$="isIndeterminate$"
  let-selection="selection"
  let-multipleActions="multipleActions"
  let-singleAction="singleAction"
>
  <div
    class="table-desktop"
    [style.width]="config.wrapperWidth"
    [style.height]="config.wrapperHeight"
    [class.table-desktop--scrollable]="config.scrolling"
  >
    <mat-table
      #table
      matSort
      cdkDropList
      [matSortActive]="config.activeSort?.id"
      [matSortDirection]="config.activeSort?.start"
      [matSortDisableClear]="config.activeSort?.disableClear"
      *ngIf="initTable(config)"
      [dataSource]="config.dataSource"
      [style.width]="config.width"
      [style.height]="config.height"
      [class.table-desktop__table--scrollable]="config.scrolling"
      [class.table-desktop__table--alternate-rows]="config.alternateRows"
    >
      <ng-container
        [matColumnDef]="tableColumnTypesFixed.DRAG_DROP"
        [sticky]="config.dragDrop === tableStickyTypes.STICKY"
      >
        <mat-header-cell
          *matHeaderCellDef
          class="table-desktop__col-drag"
          data-test="table-desktop__col-drag-header"
        ></mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="table-desktop__col-drag"
          data-test="table-desktop__col-drag"
          ><mat-icon>drag_handle</mat-icon></mat-cell
        >
        <mat-footer-cell *matFooterCellDef class="table-desktop__col-drag"></mat-footer-cell>
      </ng-container>

      <ng-container
        [matColumnDef]="tableColumnTypesFixed.SELECT"
        [sticky]="config.select === tableStickyTypes.STICKY"
      >
        <mat-header-cell
          *matHeaderCellDef
          class="table-desktop__col-select"
          data-test="table-desktop__col-select-header"
        >
          <mat-checkbox
            color="primary"
            class="spacing--margin-horizontal"
            [formControl]="selectAllCheckbox"
            [checked]="allRowsSelected$ | async"
            [indeterminate]="isIndeterminate$ | async"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="table-desktop__col-select"
          data-test="table-desktop__col-select"
        >
          <mat-checkbox
            color="primary"
            class="spacing--margin-horizontal"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="table-desktop__col-select"></mat-footer-cell>
      </ng-container>

      <ng-container
        [matColumnDef]="tableColumnTypesFixed.ACTION"
        [stickyEnd]="config.action === tableStickyTypes.STICKY"
      >
        <mat-header-cell
          *matHeaderCellDef
          class="table-desktop__col-actions"
          [class.table-desktop__col-multiple-actions]="singleAction && multipleActions.length > 0"
          [class.table-desktop__col-single-action]="
            (singleAction && multipleActions.length === 0) ||
            (!singleAction && multipleActions.length > 0)
          "
          [class.table-desktop__col-hideActionLabel]="config.hideActionLabel"
        >
          {{ config.actions.length === 1 ? ('action' | translate) : ('actions' | translate) }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="table-desktop__col-actions"
          [class.table-desktop__col-single-action]="
            (singleAction && multipleActions.length === 0) ||
            (!singleAction && multipleActions.length > 0)
          "
          [class.table-desktop__col-multiple-actions]="singleAction && multipleActions.length > 0"
          [class.table-desktop__col-hideActionLabel]="config.hideActionLabel"
          data-test="table-desktop__col-actions"
        >
          <div class="flex--row flex--nowrap">
            <ng-container *ngIf="singleAction">
              <button
                *ngIf="config.hideActionLabel; else actionLabel"
                mat-icon-button
                [disabled]="singleAction.disabled(row, singleAction.id)"
                (click)="singleAction.callback(row, singleAction.id); $event.stopPropagation()"
                [attr.data-test]="'table-desktop__col-actions-' + singleAction.id"
              >
                <mat-icon>{{ singleAction.icon }}</mat-icon>
              </button>
              <ng-template #actionLabel>
                <button
                  mat-flat-button
                  [disabled]="singleAction.disabled(row, singleAction.id)"
                  (click)="singleAction.callback(row, singleAction.id); $event.stopPropagation()"
                  [attr.data-test]="'table-desktop__col-actions-' + singleAction.id"
                >
                  <mat-icon>{{ singleAction.icon }}</mat-icon>
                  {{ singleAction.label }}
                </button>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="multipleActions.length > 0">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                (click)="$event.stopPropagation()"
                data-test="table-desktop__col-actions-button"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let action of multipleActions"
                  [disabled]="action.disabled(row, action.id)"
                  (click)="action.callback(row, action.id); $event.stopPropagation()"
                  [attr.data-test]="'table-desktop__col-actions-' + action.id"
                >
                  <mat-icon>{{ action.icon }}</mat-icon>
                  <span>{{ action.label }}</span>
                </button>
              </mat-menu>
            </ng-container>
          </div>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="table-desktop__col-actions"></mat-footer-cell>
      </ng-container>

      <ng-container
        *ngFor="let column of config.columns || []; let i = index; trackBy: trackByIndex"
      >
        <ng-container
          [matColumnDef]="column.id"
          [sticky]="column.sticky === tableColumnStickyTypes.START"
          [stickyEnd]="column.sticky === tableColumnStickyTypes.END"
        >
          <!-- header -->
          <ng-container *ngIf="!column.disableSort && column.type !== tableColumnTypes.TEMPLATE">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [attr.data-test]="'table-desktop__col-' + column.id + '-header'"
              [class]="'table-desktop__col-' + column.type + '-header'"
            >
              {{ column.label }}
            </mat-header-cell>
          </ng-container>
          <ng-container *ngIf="column.disableSort || column.type === tableColumnTypes.TEMPLATE">
            <mat-header-cell
              [attr.data-test]="'table-desktop__col-' + column.id + '-header'"
              [class]="'table-desktop__col-' + column.type + '-header'"
              *matHeaderCellDef
            >
              {{ column.label }}
            </mat-header-cell>
          </ng-container>

          <!-- body -->
          <mat-cell
            *matCellDef="let row; let i = index"
            [attr.data-test]="'table-desktop__col-' + column.id"
            [class]="'table-desktop__col-' + column.type"
          >
            <ng-container *ngIf="column.type === tableColumnTypes.NUMBER">
              <span class="spacing--margin-right spacing--padding-right">{{
                column?.disableFormatting
                  ? row[column.id]
                  : getValue(row[column.id], column?.digitsInfo)
              }}</span>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.CURRENCY">
              <span class="spacing--margin-right spacing--padding-right">{{
                column?.disableFormatting ? row[column.id] : (row[column.id] | agrCurrency)
              }}</span>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.DATE">
              <span class="spacing--margin-right spacing--padding-right">{{
                column?.disableFormatting ? row[column.id] : (row[column.id] | agrDate: 'shortDate')
              }}</span>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.IDENTIFIER">
              <agr-identifier-trigger
                [data]="row[column.id]"
                (click)="$event.stopPropagation()"
              ></agr-identifier-trigger>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.STRING">
              {{ row[column.id] }}
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.TEMPLATE && !!column.template">
              <ng-container
                *ngTemplateOutlet="column.template; context: { row: row }"
              ></ng-container>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.INPUT_STRING">
              <mat-form-field
                (click)="$event.stopPropagation()"
                class="full-width-field spacing--padding-right mat-form-field__no-spacing"
              >
                <input
                  matInput
                  placeholder="{{ column.label }}"
                  [formControl]="column.inputConfig.formArray.at(i)"
                  (keyup)="
                    column?.inputConfig?.callback
                      ? column.inputConfig.callback(row, column.inputConfig.formArray.at(i))
                      : false
                  "
                />
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="column.type === tableColumnTypes.INPUT_NUMBER">
              <mat-form-field
                (click)="$event.stopPropagation()"
                class="full-width-field spacing--padding-right mat-form-field__no-spacing"
              >
                <input
                  matInput
                  step="{{ column.inputConfig.step || 1 }}"
                  agrNumber
                  placeholder="{{ column.label }}"
                  (keyup)="
                    column?.inputConfig?.callback
                      ? column.inputConfig.callback(row, column.inputConfig.formArray.at(i))
                      : false
                  "
                  [formControl]="column.inputConfig.formArray.at(i)"
                />
              </mat-form-field>
            </ng-container>
          </mat-cell>

          <!-- footer -->
          <mat-footer-cell
            *matFooterCellDef
            [attr.data-test]="'table-desktop__col-' + column.id + '-footer'"
            [class]="'table-desktop__col-' + column.type + '-footer'"
            class="table-desktop__footer"
          >
            <ng-container
              *ngIf="
                column.footerValueTypes &&
                (column.type === tableColumnTypes.NUMBER ||
                  column.type === tableColumnTypes.CURRENCY)
              "
            >
              <span *ngIf="column.footerDescription" class="table-desktop__footer-description">
                {{ column.footerDescription }}
              </span>

              <span class="spacing--margin-right spacing--padding-right">
                {{ getFooterValue(column.id, config) | agrNumber }}
              </span>
            </ng-container>
          </mat-footer-cell>
        </ng-container>
      </ng-container>

      <!-- custom footers -->
      <ng-container
        *ngFor="
          let footerColumns of getCustomFooters(config);
          let iValue = index;
          trackBy: trackByIndex
        "
      >
        <ng-container *ngFor="let footerColumn of footerColumns">
          <ng-container [matColumnDef]="footerColumn.id">
            <mat-footer-cell *matFooterCellDef>
              <ng-container>
                <ng-container *ngFor="let column of config.columns">
                  <ng-container
                    *ngIf="
                      column.id === footerColumn.referenceId &&
                      column.type === tableColumnTypes.STRING
                    "
                  >
                    <span [ngClass]="{ sticky: column.id === 'locationName' }">
                      {{ getCustomFooterValue(column?.customfooterValues, iValue) }}
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      column.id === footerColumn.referenceId &&
                      column.type !== tableColumnTypes.STRING
                    "
                  >
                    <span
                      class="table-desktop__footer table-desktop__col-{{
                        column.type
                      }}-footer spacing--margin-right spacing--padding-right"
                    >
                      {{ getCustomFooterValue(column?.customfooterValues, iValue) }}
                    </span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-footer-cell>
          </ng-container>
        </ng-container>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="
          !!config.header ? columnIds : [];
          sticky: config.header === tableStickyTypes.STICKY
        "
        [class.table-desktop--hidden]="!config.header"
      ></mat-header-row>
      <mat-row
        cdkDrag
        [cdkDragDisabled]="!config.dragDrop"
        (cdkDragDropped)="dragDropped(config, $event, row)"
        *matRowDef="let row; columns: columnIds"
        [ngClass]="{ 'table-desktop__row--clickable': config?.rowClickAction?.callback }"
        (click)="
          config?.rowClickAction?.callback
            ? config.rowClickAction.callback(row, config.rowClickAction.id)
            : false;
          $event.stopPropagation()
        "
      ></mat-row>
      <mat-footer-row
        *matFooterRowDef="
          !!config.footer ? columnIds : [];
          sticky: config.footer === tableStickyTypes.STICKY
        "
        [class.table-desktop--hidden]="!config.footer"
      ></mat-footer-row>
      <ng-container
        *ngFor="
          let footerColumns of getCustomFooterRowIds(config);
          let ii = index;
          trackBy: trackByIndex
        "
      >
        <mat-footer-row
          *matFooterRowDef="footerColumns"
          class="table-desktop__custom-footer-rows"
          [class.table-desktop--hidden]="!getFooterVisibility(config)[ii]"
        ></mat-footer-row>
      </ng-container>
    </mat-table>
  </div>
</ng-template>
